export const globalEnvironmentConfig = {
    ApiBaseUrl: "#{IntakeClient:ApiBaseUrl}",
    Auth0: {
        Domain: "#{Auth0:Domain}",
        ClientId: "#{Auth0:ClientId}",
        RedirectUri: "#{Auth0:RedirectUri}",
        Audience: "#{Auth0:Audience}",
    },
    Gladson: {
        ApiUri: "/api",
    },
    EnableLogging: "#{EnableLogging}",
};
